import { format } from 'date-fns';

export function currency(value: any, d = ',', t = '.', precision = 2) {
    let v = value ? value : 0;
    let s = v < 0 ? '-' : '';
    let i = parseInt(Math.abs(v.toFixed(precision)) + '', 10) + '';
    let j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : '')
        + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t)
        + (precision ? d + Math.abs(v - parseInt(s + i, 10)).toFixed(precision).slice(precision) : '');
}

export function localizedDate(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'P', { locale });
}

export function extendedDate(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'iiii d MMMM yyyy', { locale });
}

export function day(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'd', { locale });
}

export function dayName(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'iiii', { locale });
}

export function dayNameShort(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'iii', { locale });
}

export function monthName(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'MMMM', { locale });
}


export const filters = {
    currency,
    localizedDate,
    extendedDate,
    day,
	dayName,
	dayNameShort,
    monthName,
}
